import { gql } from '@apollo/client'

export const COMPLETE_UNIFIED_ONBOARDING = gql`
  mutation completeUnifiedOnboarding {
    completeUnifiedOnboarding {
      success
    }
  }
`
